
























































































import {
  defineComponent, computed, watch, reactive, ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import { useQuery, useResult, useMutation } from '@vue/apollo-composable';

import ViewOnlyGuard from '@/components/ViewOnlyGuard.vue';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonDropzoneWithImageUpload from '@/components/CommonDropzoneWithImageUpload.vue';
import CommonImageTable from '@/components/Table/CommonImageTable.vue';

import getKnowledge from '@/gql/getKnowledge.gql';
import createKnowledge from '@/gql/createKnowledge.gql';
import updateKnowledge from '@/gql/updateKnowledge.gql';

import log from '@/table/log';

const KnowledgeEditor = defineComponent({
  setup() {
    /* ==== Get meta data ==== */
    const { route } = useRouter();
    // eslint-disable-next-line
    const mode = route.value.meta.mode;
    const modeDisplay = computed(() => {
      if (mode === 'create') return 'เพิ่ม';
      if (mode === 'edit') return 'แก้ไข';
      if (mode === 'view') return 'ดู';
      return '';
    });
    // Try to destructor but doesn't work Q^Q

    // eslint-disable-next-line
    const handicraftTypeId = route.value.params.handicraftTypeId;

    /* ===== Menu manager ===== */
    const editorMenu = [
      { id: 0, status: true, display: 'หัวข้อและคำอธิบาย' },
      { id: 1, status: false, display: 'ภาพประกอบ' },
      { id: 2, status: false, display: 'ประวัติการแก้ไข' },
    ];

    function changeActiveMenu(index: number) {
      for (let i = 0; i < editorMenu.length; i += 1) {
        if (editorMenu[index].id === i) editorMenu[i].status = true;
        else editorMenu[i].status = false;
      }
    }
    // ========================= //

    /* ==== Define form ==== */
    const form = reactive({
      name: '',
      description: '',
      logs: '',
      images: [],
    });
    // ===============================

    /* ==== Validate to submit button ==== */
    const validated = computed(() => {
      if (form.name === '' || form.name === undefined) return false;
      return true;
    });

    const saveModal = ref(null);
    function pendingSubmit() {
      if (validated.value) (saveModal.value as any).open();
    }
    // ========================= //

    /* ==== Upload code ==== */
    // ===================== //

    /* ==== Get value when enter edit mode */
    const isQueryEnabled = ref(true);
    const { result: knowledgeResult } = useQuery(getKnowledge, computed(() => ({
      id: route.value.params.knowledgeId,
    })), () => ({
      fetchPolicy: 'network-only',
      enabled: isQueryEnabled.value,
    }));
    watch(knowledgeResult, () => {
      const knowledge = useResult(knowledgeResult, null, (data) => data.knowledge);
      const item = knowledge.value;
      if (item) isQueryEnabled.value = false; // if value is loaded, disable next query
      form.name = item?.name;
      form.images = item?.images;
      form.description = item?.description;
      form.logs = item?.logs;
    });

    const computedImages = computed(() => {
      const temp: any = [];
      // eslint-disable-next-line
      form.images?.forEach((element: any) => {
        temp.push(parseInt(element.id, 10));
      });
      return temp;
    });

    // --------------------------- //
    // ===== Create Mutation ===== //
    // --------------------------- //
    const createKnowledgeMutation = useMutation(createKnowledge,
      () => ({
        variables: {
          type: handicraftTypeId,
          name: form.name,
          description: form.description,
          images: computedImages.value,
        },
        refetchQueries: ['getKnowledges', 'getHandicraftTypes'],
      }));

    // --------------------------- //
    // ===== Update Mutation ===== //
    // --------------------------- //
    const updateKnowledgeMutation = useMutation(updateKnowledge,
      () => ({
        variables: {
          id: route.value.params.knowledgeId,
          // type: route.value.params.handicraftTypeId, // TODO: Pending removal on backend (unneccesary)
          name: form.name,
          description: form.description,
          images: computedImages.value,
        },
        refetchQueries: ['getKnowledges', 'getHandicraftTypes'],
      }));

    const computedMutation = computed(() => {
      if (mode === 'create') return createKnowledgeMutation;
      return updateKnowledgeMutation;
    });

    function onImageUploadDone(newImage: never) {
      if (!form.images) form.images = [];
      form.images.push(newImage);
    }

    return {
      onImageUploadDone,
      mode,
      modeDisplay,
      editorMenu,
      changeActiveMenu,
      form,
      log,
      computedMutation,
      handicraftTypeId,
      validated,
      pendingSubmit,
      saveModal,
    };
  },
  components: {
    ViewOnlyGuard,
    CommonConfirmDialog,
    CommonDropzoneWithImageUpload,
    CommonImageTable,
  },
  props: {
    role: {},
  },
});

export default KnowledgeEditor;
